'use client';

import React, { useCallback, useState, useEffect } from 'react';
import { Solicitud } from '@/types/solicitud';
import SolicitudManagement from './SolicitudManagement';
import { solicitudService } from '@/lib/api/solicitudService';
import { getCurrentUser } from '@/services/authService';
import ErrorMessage from '@/components/common/ErrorMessage';

/**
 * Módulo Análisis de Créditos:
 * - estatus = "ENTREGA A RIESGOS"
 * - fechaPrimerSolicitudVoBo == "" (sin VoBo)
 * - fechaRevisionDocumentalConcluida != "" (revisión documental completada)
 * - fechaAnalisisConluido == "" (análisis no completado)
 *
 * Nota: A diferencia de Pre Análisis, este módulo actualiza directamente la solicitud
 * sin generar propuestas intermedias.
 */
const AnalisisCreditosManagement: React.FC = () => {
  const [initialSolicitudes, setInitialSolicitudes] = useState<Solicitud[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAnalisisCreditos = useCallback(async () => {
    setLoading(true);
    setError(null);
    const currentUser = getCurrentUser();
    if (!currentUser || !currentUser.ownerID) {
      setError("No se pudo obtener el ID del usuario actual.");
      setLoading(false);
      return;
    }
    try {
      const response = await solicitudService.getAnalisisCreditos(currentUser.ownerID);
      if (response.data) {
        setInitialSolicitudes(response.data);
      } else {
        setError(response.error || "Error al cargar solicitudes de Análisis de Créditos.");
      }
    } catch (err: any) {
      setError(err.message || "Error de red al cargar solicitudes.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAnalisisCreditos();
  }, [fetchAnalisisCreditos]);

  if (loading) {
    return <div className="text-center py-4">Cargando solicitudes...</div>;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  return (
    <SolicitudManagement
      fixedStatus="ENTREGA A RIESGOS"
      title="Análisis de Créditos"
      modulo="analisis-credito"
      initialSolicitudes={initialSolicitudes}
      customFetch={fetchAnalisisCreditos}
      showNewButton={false}
    />
  );
};

export default AnalisisCreditosManagement;
